export default __webpack_public_path__ + "static/DSC5381_1584x396-7f97ac1f8c66d18d8485463e55247ffb.jpg";